import UIBaseComponent from "@baseUI/component/base/UIBaseComponent";

export default class UIBaseLayout extends UIBaseComponent {

    constructor() {
        super()
    }

}